import { useAllGroupsSelectorQuery } from "generated/graphql"

function useExternalGroups() {
  const { data } = useAllGroupsSelectorQuery({
    variables: {
      category: "EXT",
    },
  })
  return data?.allGroups
}
export default useExternalGroups
